import React from 'react';
import { Button, Modal } from '@livecommerce/design-system';

const name = 'close-confirmation-dialog';

const CloseConfirmationDialog = ({ handleConfirmCancelClick, handleConfirmDiscardClick, isConfirmDialogOpen }) => {
  return (
    <Modal
      name={name}
      isModalOpen={isConfirmDialogOpen}
      onClose={handleConfirmCancelClick}
      title="Do you want to discard these unsaved changes?"
      variant="confirmation"
      actions={
        <>
          <Button type="button" variant="regular" onClick={handleConfirmCancelClick}>
            Cancel
          </Button>
          <Button type="button" variant="primary" onClick={handleConfirmDiscardClick}>
            Yes, discard
          </Button>
        </>
      }
    >
      If you discard the changes, they will be permanently deleted.
    </Modal>
  );
};
export default CloseConfirmationDialog;
